import $ from 'jquery';

// jQuery globalnie (odpowiednik ProvidePlugin + expose-loader z webpacka) - wymagane
// m.in. przez wtyczki jQuery Bootstrapa i skrypty inline w widokach.
window.$ = window.jQuery = $;
